import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginStart, loginSuccess, loginFailure } from '../redux/authSlice';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(loginStart());

    try {
      const response = await axios.post(`${apiBaseUrl}login`, { email, password });
      console.log(response.data);
      setErrorMsg('');
      if(response.data.type == 'success'){
        dispatch(loginSuccess(response.data));
        navigate('/');
      }
      else{
        setErrorMsg(response.data.message);
        loading(false);
      }
    } catch (err) {
      dispatch(loginFailure(err.response?.data?.message || 'Something went wrong'));
    }
  };

  return (
    <div className='container'>
      <div className='row text-center'>
        <h3>LOGIN</h3>
      </div>
      <form onSubmit={handleSubmit}>
        <div className='row'>
          <div className='col-md-12 mb-3'>
            <label>Email</label>
            <input
            type="email"
            placeholder="Email"
            value={email}
            className='form-control'
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          </div>
          <div className='col-md-12 mb-3'>
            <label>Password</label>
            <input
            type="password"
            className='form-control'
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          </div>
        </div>
        <div className='mb-3 text-danger'>
          {errorMsg}
        </div>
        <div className='text-center'>
          <button type="submit" className='btn btn-outline-success' disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Login;
